import React from 'react';
import PropTypes from 'prop-types';
import { Box, Fab, Typography, Stack } from '@mui/material';
import { isEmpty } from 'lodash';
import { makeStyles } from '@mui/styles';
import useTimeStore from '../ZustandProvider';

const IntroductionMapComponent = ({ changeLoading, MapProps }) => {
  const layers = useTimeStore(state => state.layers);
  const mapTypeView = useTimeStore(state => state.mapTypeView);
  const setMapTypeView = useTimeStore(state => state.setMapTypeView);
  const setAdjustMap = useTimeStore(state => state.setAdjustMap);

  const { mapTypes, textSettings } = MapProps.map.settingsAdvancedMap;

  const useStyles = makeStyles(() => ({
    fabWithPhoto: {
      position: 'relative',
      overflow: 'hidden',
      borderRadius: '50%',
      width: '56px',
      height: '56px'
    },
    photo: {
      width: '100%',
      height: '100%',
      objectFit: 'cover'
    }
  }));
  const classes = useStyles();

  const handleChangeMapType = typeMap => {
    if (typeMap !== mapTypeView) {
      setAdjustMap(false);
      changeLoading(600);
      setTimeout(() => {
        setMapTypeView(typeMap);
      }, 200);
      setTimeout(() => {
        setAdjustMap(true);
      }, 400);
    }
  };

  const imageButton = value => {
    switch (value) {
      case 'mapSync':
        return 'https://r.geocompx.org/figures/interactive-facets.png';
      case 'map':
        return 'https://www.unigis.es/wp-content/uploads/2019/06/Seleccio_343-2.png';
      case 'map3D':
        return 'https://www.geopois.com/images/logos/cesium_tl40mk.png';
      // comment decks
      // case 'mapDeckGL':
      //   return 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSugMT99mHkzmhxUCjA0BZRx4K5ABC-70cC0A&usqp=CAU';
      default:
        return 'https://www.unigis.es/wp-content/uploads/2019/06/Seleccio_343-2.png';
    }
  };

  return (
    <Box display="flex" flexDirection="column" gap={2} height="100%" mb={2}>
      {textSettings.showTitle && textSettings.showTitle === true && (
        <Typography
          align="center"
          style={{
            fontSize: `${textSettings.title}px`,
            fontFamily: textSettings.font
          }}
          sx={{ color: 'black', fontFamily: 'Arial' }}
          variant="h3"
        >
          {MapProps.map.name}
        </Typography>
      )}
      {textSettings.showImagen && textSettings.showImagen === true && (
        <>
          {!isEmpty(layers) && !isEmpty(layers[0].imageUrl) && (
            <Box
              sx={{
                alignSelf: 'center',
                mb: 1,
                maxHeight: '20%',
                width: '100%',
                display: 'flex',
                justifyContent: 'center'
              }}
            >
              <img
                src={layers[0].imageUrl}
                alt="imagen"
                style={{ maxHeight: '100%', maxWidth: '100%', objectFit: 'contain' }}
              />
            </Box>
          )}
        </>
      )}

      <Box
        sx={{
          overflowY: 'auto',
          maxHeight: '70%',
          height: `${textSettings.descriptionHeight}%`
        }}
      >
        <Typography
          variant="body1"
          component="div"
          style={{
            fontSize: `${textSettings.description}px`,
            fontFamily: textSettings.font
          }}
        >
          {/* eslint-disable-next-line react/no-danger */}
          <div dangerouslySetInnerHTML={{ __html: MapProps.map.description }} />
        </Typography>
      </Box>
      {mapTypes && mapTypes.length !== 1 && (
        <Stack direction="row" spacing={1}>
          {mapTypes.map(item => (
            <Fab
              aria-label={item.name}
              onClick={() => handleChangeMapType(item.value)}
              className={classes.fabWithPhoto}
              key={item.value}
            >
              <img
                src={imageButton(item.value)}
                alt={item.name}
                loading="lazy"
                className={classes.photo}
              />
            </Fab>
          ))}
        </Stack>
      )}
      {!isEmpty(textSettings.logo) && (
        <Box display="flex" justifyContent="flex-end">
          <Box
            component="img"
            src={textSettings.logo}
            alt="logo"
            sx={{
              maxWidth: '100px'
            }}
          />
        </Box>
      )}
    </Box>
  );
};

IntroductionMapComponent.defaultProps = {
  changeLoading: () => {},
  MapProps: {},
  map: {}
};
IntroductionMapComponent.propTypes = {
  changeLoading: PropTypes.func,
  MapProps: PropTypes.object,
  map: PropTypes.object
};

export default IntroductionMapComponent;
